<template>
  <div class="tournament-slots-games-slider" :class="{ active }" v-if="game_slugs">
    <div v-for="slug in game_slugs" :key="slug">
      <div class="slider-games-item">
        <router-link :to="{ name: 'game', params: { game: slug } }" class="slider-games-item-image">
          <img :src="gameBySlug(slug)?.icon" :alt="gameBySlug(slug)?.title" />
        </router-link>

        <div class="slider-games-item-over">
          <router-link :to="{ name: 'game', params: { game: slug } }" class="sgio-link"
            ><i>Играть</i><span>{{ gameBySlug(slug)?.title }}</span></router-link
          >
          <div class="slider-games-label">
            <a href="#" class="slider-games-brands1"><img src="/images/go-ico-yellow2.svg" alt="" /></a>
          </div>

          <template v-if="isAuthenticated">
            <a v-if="!this.favourites?.includes(slug)" @click="this.addToFavourite(slug)" class="slider-games-likes" />
            <a v-else @click="this.removeFromFavourite(slug)" class="slider-games-likes active"></a>
          </template>
        </div>
      </div>
    </div>
  </div>
  <div class="more" :class="{ active }" @click="active = !active" v-if="game_slugs.length > 6">
    Показать еще 20 слотов
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from 'swiper/vue'
import { Navigation } from 'swiper/modules'
import { useI18n } from 'vue-i18n'
import { mapGetters } from 'vuex'
import { ADD_TO_FAVOURITE, REMOVE_FROM_FAVOURITE } from '@/store/actions.type'

export default {
  name: 'SliderTournamentGames',
  components: {
    Swiper,
    SwiperSlide,
  },
  props: {
    game_slugs: {
      type: Array,
      required: true,
    },
  },
  computed: {
    ...mapGetters(['gameBySlug', 'favourites', 'isAuthenticated']),
  },
  setup() {
    const { t, locale } = useI18n()

    return {
      modules: [Navigation],
      t,
      locale,
    }
  },
  data() {
    return {
      active: false,
    }
  },
  methods: {
    addToFavourite(slug) {
      this.$store.dispatch(ADD_TO_FAVOURITE, { slug })
    },
    removeFromFavourite(slug) {
      this.$store.dispatch(REMOVE_FROM_FAVOURITE, { slug })
    },
  },
}
</script>

<style scoped></style>
